module.exports = __webpack_public_path__ + "media/metronic/_theme/media/icons/svg/Home/Couch-47e5cd2e1d78bbc2142cb2ee69591fac.svg";